import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

interface SearchDropdownProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  buttonClassName?: string;
  iconClassName?: string;
  label?: string;
}

export const SearchDropdown: React.FC<SearchDropdownProps> = ({
  value,
  onChange,
  placeholder = 'Search across all fields',
  buttonClassName,
  iconClassName,
  label = 'Search',
}) => {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className={cn("gap-2", buttonClassName)}>
          <Search className={cn("h-4 w-4", iconClassName)} />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-96 p-3">
        <Input
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoFocus
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
